// extracted by mini-css-extract-plugin
export default {"player":"VideoPlayer_player__aLJL2","progress":"VideoPlayer_progress__QUews"};